module.exports = __webpack_public_path__ + "img/11825377_L.f2fc03d7.png";